import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import { PluginDetails } from './index';
import CustomLoader from '../common/CustomLoader';
import DocsLink from '../../common/custom/DocsLink';
import ParentDocCard from '../common/ParentDocCard';
import ParentCardNoCol from '../common/ParentCardNoCol';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { showAlertHtml } from '../../common/utils/alert';
import { PLUGIN, pluginCode } from 'drapcode-constant';

export class DefaultPage extends Component {
  static propTypes = {
    plugin: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { searchTerm: '', searched: false, extensionsSearchList: [] };
  componentDidMount() {
    const { projectId, version } = this.props.match.params;
    this.props.actions.loadAllExtension({ projectId, version });
    this.props.actions.loadAllInstalledPlugin({ projectId, version });
    this.props.actions.deletePermission({ projectId });
    this.props.actions.loadProjectDetail({ projectId, version });
  }

  handleDelete = (installedPluginId) => {
    const {
      plugin: { installedPlugins },
      match,
      actions,
    } = this.props;
    const selectedPlugin =
      installedPlugins && installedPlugins.find((plugin) => plugin.uuid === installedPluginId);
    const { code } = selectedPlugin || '';
    const { projectId, version } = match.params;
    const preConfirm = () => {
      actions.deleteInstalledPlugin({ projectId, installedPluginId, version });
    };

    let alertMsg = "You won't be able to revert this.";
    switch (code) {
      case pluginCode.MULTI_TENANT_SAAS:
        alertMsg = `You won't be able to revert this.</br></br>
        <p style="text-align: left;">
        1. Tenant Collection's reference field will be removed from all the existing collections.</br></br>
        2. A <em>All Items of Current LoggedIn User Tenant</em> filter will be removed from all the existing collections.</br></br>
        3. The selected Tenant collection will be reverted to default DrapCode collection.
        </p>
        `;
        break;
      case pluginCode.DATA_FORM_SEARCH_HISTORY:
        alertMsg = `You won't be able to revert this.</br></br>
          <p style="text-align: left;">
          1. Search History Collection will be removed.</br></br>
          2. Enable Search History trait option will be removed from Search Form component.</br></br>
          </p>
          `;
        break;
      case pluginCode.FILE_ACTIVITY_TRACKER:
        alertMsg = `You won't be able to revert this.</br></br>
          <p style="text-align: left;">
          1. File Activity Tracker Collection will be removed.</br></br>
          </p>
          `;
        break;
      case pluginCode.USER_ACTIVITY_TRACKER:
        alertMsg = `You won't be able to revert this.</br></br>
          <p style="text-align: left;">
          1. User Login Activity Collection will be removed.</br></br>
          </p>
          `;
        break;
      case pluginCode.DATA_VIEW_ACTIVITY_TRACKER:
        alertMsg = `You won't be able to revert this.</br></br>
          <p style="text-align: left;">
          1. Data View Activity Tracker Collection will be removed.</br></br>
          </p>
          `;
        break;
      case pluginCode.TEXT_ANONYMIZATION_ACTIVITY_TRACKER:
        alertMsg = `You won't be able to revert this action.</br></br>
          <p style="text-align: left;">
          1. Text Anonymization Activity Collection will be permanently removed.</br></br>
          2. Text anonymization events will no longer be visible.</br></br>
          </p>
          `;
        break;
      case pluginCode.TYPESENSE_SEARCH:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. Typesense Search capabilities will be removed.</br></br>
            2. Typesense Configuration will be permanently removed.</br></br>
            3. Typesense Events will no longer be visible.</br></br>
            4. Typesense Component will no longer be visible.</br></br> 
            </p>
            `;
        break;
      case pluginCode.SOCKET_IO:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. Socket.IO capabilities will be removed.</br></br>
            2. Socket Actions will no longer be visible.</br></br>
            3. Socket.IO templates will no longer be visible.</br></br> 
            4. Socket.IO Activity Tracker Collection will be removed.</br></br>
            </p>
            `;
        break;
      case pluginCode.SENDGRID:
        alertMsg = `You won't be able to revert this action.</br></br>
            <p style="text-align: left;">
            1. Email sending via SendGrid will be disabled.</br></br>
            2. The Send Dynamic Email action will no longer support the SendGrid service.</br></br>
            3. The SendGrid Activity Tracker collection will be deleted.</br></br>
            </p>
            `;
        break;
      default:
        break;
    }

    showAlertHtml(alertMsg, preConfirm, 'Yes, delete it!');
  };

  getAvailablePlugins = (installedPlugins, extensions) => {
    const installedPluginsCode = installedPlugins.map((plugin) => {
      return plugin.code;
    });
    return extensions.filter((plugin) => {
      return !installedPluginsCode.includes(plugin.code);
    });
  };

  handleSearch = () => {
    const { searchTerm } = this.state;
    const {
      plugin: { extensions, installedPlugins },
    } = this.props;
    const availablePlugins = this.getAvailablePlugins(installedPlugins, extensions);
    const extensionsSearchList = availablePlugins.filter((plugin) => {
      if (!searchTerm) {
        return plugin;
      } else if (plugin.name.toLowerCase().includes(searchTerm.toLowerCase())) {
        return plugin;
      }
    });

    this.setState({ extensionsSearchList, searched: true });
  };

  showPluginsCard = (showInstalledPlugin, projectType, checkPermission) => {
    const { plugin, match } = this.props;
    const { projectId, version } = match.params;
    const { extensions, installedPlugins, permissionFlags } = plugin;

    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }
    const { extensionsSearchList } = this.state;
    const availablePlugins = this.getAvailablePlugins(installedPlugins, extensions);
    const isSearched = extensionsSearchList && extensionsSearchList.length > 0;
    if (showInstalledPlugin && extensions && extensions.length > 0) {
      return installedPlugins.map((plugin) => {
        return (
          <div className="grid__column" key={plugin.name}>
            <PluginDetails
              currentPlugin={plugin}
              key={plugin.name}
              projectId={projectId}
              version={version}
              handleDelete={this.handleDelete}
              showInstalledPlugin={showInstalledPlugin}
              checkPermission={checkPermission}
              extensions={extensions}
              flag={permissionsArray.includes(PLUGIN)}
            />
          </div>
        );
      });
    } else if (isSearched) {
      return extensionsSearchList.map((plugin) => {
        return (
          <div className="grid__column" key={plugin.name}>
            <PluginDetails
              currentPlugin={plugin}
              key={plugin.name}
              projectId={projectId}
              version={version}
              handleDelete={this.handleDelete}
              showInstalledPlugin={showInstalledPlugin}
              checkPermission={checkPermission}
              extensions={extensions}
            />
          </div>
        );
      });
    } else if (this.state.searched && !isSearched) {
      return <h4>No Plugins Found!</h4>;
    } else {
      return availablePlugins.map((plugin) => {
        return (
          <div className="grid__column" key={plugin.name}>
            <PluginDetails
              currentPlugin={plugin}
              key={plugin.name}
              projectId={projectId}
              version={version}
              handleDelete={this.handleDelete}
              showInstalledPlugin={showInstalledPlugin}
              checkPermission={checkPermission}
              extensions={extensions}
            />
          </div>
        );
      });
    }
  };

  updateSearchTerm = (value) => {
    this.setState({ searchTerm: value });
  };

  render() {
    const { projectId, version } = this.props.match.params;
    const { installedPlugins, loadAllExtensionPending, loadAllInstalledPluginPending } =
      this.props.plugin;
    const { common } = this.props;
    const { projectDetail } = common;
    let projectType = projectDetail && projectDetail.projectType ? projectDetail.projectType : '';

    return (
      <CommonPageComponent>
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            <ParentCardNoCol icon="plugins" title="Installed Plugins">
              <div className="center-div">
                <div className="container ml-0">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <div className="grid grid--user-profile">
                        {loadAllInstalledPluginPending ? (
                          <div className="text-center">
                            <CustomLoader
                              loading={loadAllInstalledPluginPending}
                              size="20px"
                              color="#303453"
                            />
                          </div>
                        ) : installedPlugins && installedPlugins.length > 0 ? (
                          this.showPluginsCard(true, projectType, false)
                        ) : (
                          <h3>No Installed Plugins!</h3>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ParentCardNoCol>
            <ParentCardNoCol
              bgColor="drapcode-violet"
              icon="plugins"
              title="Available Plugins"
              isSearch={true}
              handleSearch={this.handleSearch}
              updateSearchTerm={this.updateSearchTerm}
            >
              <div className="center-div">
                <div className="container ml-0">
                  <div className="row mx-auto">
                    <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                      <div className="grid grid--user-profile">
                        {loadAllExtensionPending ? (
                          <div className="text-center">
                            <CustomLoader
                              loading={loadAllExtensionPending}
                              size="20px"
                              color="#303453"
                            />
                          </div>
                        ) : (
                          <>{this.showPluginsCard(false, projectType, true)}</>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ParentCardNoCol>
          </div>
          <ParentDocCard>
            <h5>
              <b>About Plugins</b>
            </h5>
            <p>
              Contains all the third-party plugins that allow you to easily integrate additional
              functionalities to your no code/low code web applications.
            </p>
            <br />
            <DocsLink link="https://academy.drapcode.com/docs/app-plugin/plugin-introduction/" />
          </ParentDocCard>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    plugin: state.plugin,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions, ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
